import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function FeaturedSection() {
  const featured = articles.filter((a) => a.featured);

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门精选推荐
            </h2>
            <p className="text-foreground-600 text-sm">编辑团队精心挑选的高分佳作</p>
          </div>
          <Link
            to="/category/drama"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-50 transition-all duration-300"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-white text-xs font-label font-medium rounded-full whitespace-nowrap">
                    精选
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 bg-black/60 backdrop-blur-sm rounded-full">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-white text-xs font-label font-medium">{article.rating}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.viewCount > 10000
                      ? `${(article.viewCount / 10000).toFixed(0)}万`
                      : article.viewCount}
                  </span>
                  <span>{article.year}</span>
                  <span>{article.region}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}